import { QuoteForm } from '@/components/studio/quote-form';
import { useSuspenseQuery } from '@tanstack/react-query';
import { customQuery } from '@/queries';

export default function QuoteRequestPage() {
  const { products, methods } = useSuspenseQuery(customQuery).data;

  return (
    <div className="mx-auto max-w-[1180px] px-[30px] py-12">
      <QuoteForm products={products} methods={methods} />
    </div>
  );
}
